import { render, staticRenderFns } from "./thirdLogin.vue?vue&type=template&id=211a899c&"
import script from "./thirdLogin.vue?vue&type=script&lang=js&"
export * from "./thirdLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports